export enum surveyUsersTypes {
    FETCH_SURVEY_USERS_REQUEST = 'FETCH_SURVEY_USERS_REQUEST',
    SET_SURVEY_USERS = 'SET_SURVEY_USERS',
}
